(function () {
    'use strict';

    angular
        .module('actionPlanCriteriaEditModule', [
            'services.historyCtxt',
            'actionPlanCriteriaModule',
            'recommendationModule'
        ]);
})();
